// Export a `session` object with getters so code that imports `session.jwt`
// reads the current value from localStorage at access time instead of at
// module-evaluation time. This fixes a common bug where modules read a stale
// `session` value and calls are made without the Authorization header.
export const session = {
  get raw() {
    try {
      return JSON.parse(localStorage.getItem('session'));
    } catch (e) {
      return null;
    }
  },
  get jwt() {
    const s = this.raw;
    return s && s.jwt ? s.jwt : null;
  },
  get exp() {
    const s = this.raw;
    return s && s.exp ? s.exp : null;
  }
};

// Build headers safely: only read session.jwt when session exists.
const headers = (useJwt) => {
  const token = session && session.jwt ? session.jwt : null;
  return {
    'Content-Type': 'application/json',
    Authorization: useJwt && token ? `Bearer ${token}` : null,
  };
};

export const optionsGET = (jwt = true) => ({
  method: 'GET',
  headers: headers(jwt)
})

export const optionsPOST = (body, jwt = true) => ({
  method: 'POST',
  headers: headers(jwt),
  body: JSON.stringify(body)
})

export const optionsPUT = (body, jwt = true) => ({
  method: 'PUT',
  headers: headers(jwt),
  body: JSON.stringify(body)
})

export const optionsDELETE = (jwt = true) => ({
  method: 'DELETE',
  headers: headers(jwt),
})
